
import HeaderAlertModel from "./HeaderAlert/HeaderAlertModel"
import { CartProductItem } from "../store/Cart/CartModel"
import { reducerAlertClose, reducerAppAlert as reducerAlert } from "./HeaderAlert/HeaderAlertReducer"
import { reducerLoading, reducerLoadingEnd } from "./Loading/LoadingReducer"
import { reducerCartAddressUpdate, reducerCartLoad, reducerCartProductAdd, reducerCartProductQuantityChange, reducerCartTransportUpdate } from "./Cart/CartReducer"

export function action(action: string, payload: any) {
    return { type: action, payload: payload }
}

export function actAlertShow(dispatch: any, type: string, text: string, timeoutSeconds = 3) {
    let conf: HeaderAlertModel = {
        type: type, text: text, timeoutSeconds: timeoutSeconds, show: true
    }
    return dispatch(reducerAlert(conf))
}

export function actAlertClose(dispatch: any) {
    return dispatch(reducerAlertClose())
}

export function actLoading(dispatch: any) {
    return dispatch(reducerLoading())
}

export function actLoadingEnd(dispatch: any) {
    return dispatch(reducerLoadingEnd())
}

export function actCartLoad(dispatch: any) {
    dispatch(reducerCartLoad())
}

export function actCartProductAdd(dispatch: any,product: CartProductItem) {
    dispatch(reducerCartProductAdd(product))
}

export function actCartProductQuantityChange(dispatch: any, index: number, value: number) {
    dispatch(reducerCartProductQuantityChange({ index: index, value: value }))
    //return { type: CART_PRODUCT_QUANTITY_CHANGE, payload: { index: index, value: value } }
}


export function actCartAddressUpdate(dispatch: any, addressId: number) {
    dispatch(reducerCartAddressUpdate(addressId))
    //return { type: CART_ADDRESS_UPDATE, payload: addressId }
}

export function actCartTransportUpdate(dispatch: any, transport: any){
    dispatch(reducerCartTransportUpdate(transport))

}